<template>
  <div v-bind="currentOptionAttr.data.attr" class="optional_group">
    <component
      v-bind:is="typeComponent"
      v-model="innerValue"
      :items="optionItems"
      :max="maxItem"
      :currentPageAttr="currentOptionAttr"
      solo
      x-small
    />
  </div>
</template>

<script>
import PCheckboxGroup from "./PCheckboxGroup.vue";
import PRadioGroup from "./PRadioGroup.vue";
import PDropdown from "./PDropdown.vue";
import commonMixin from "../../mixins/common";
import {
  isAvailable,
  isOutOfStockByAvailability,
  availabilityLabel,
} from "../../helpers/availability";

export default {
  mixins: [commonMixin],
  components: {
    PCheckboxGroup,
    PRadioGroup,
    PDropdown,
  },
  props: {
    currentPageAttr: Object,
    dataObject: Object,
    value: [String, Array, Object],
  },
  data() {
    return {
      innerValue: this.value,
    };
  },
  methods: {
    applyChangeStyle() {
      document.body.style.setProperty(
        "--fontSize",
        this.currentOptionAttr.data.attr.style.fontSize
      );

      document.body.style.setProperty(
        "--fontColor",
        this.currentOptionAttr.data.attr.style.color
      );
    },
  },
  mounted() {
    this.applyChangeStyle();
  },
  computed: {
    currentOptionAttr() {
      return this.currentPageAttr.productDetailBlock.data.nodes
        .productOptionalGroup.data.nodes.body;
    },
    maxItem() {
      return this.dataObject.type_limit;
    },

    optionItems() {
      return this.dataObject.products.map((item) => {

        // this is how we check status stock now
        // a little bit verbose, need to refactor later
        const statuses = JSON.parse(item.status);
        let inStock = false;
        statuses.forEach((statusItem) => {
          if (
            statusItem.stock_status.charAt(0) == process.env.VUE_APP_SHOP_ID
          ) {
            if (
              statusItem.stock_status ===
              process.env.VUE_APP_SHOP_ID + "-1"
            ) {
              inStock = true;
            } else {
              inStock = false;
            }
          }
        });

        // Smart Menu: an option outside its schedule goes through the same
        // inStock flag, so the radio/checkbox disable it and the dropdown
        // leaves it out. Stock keeps its own wording; a schedule gets the
        // availability label instead.
        const scheduled = inStock
          && !isOutOfStockByAvailability(item)
          && !isAvailable(item);
        if (!isAvailable(item)) {
          inStock = false;
        }

        let formattedPrice = this.$store.getters['theme/getIsCurrencyShownAtProduct'] ? this.$store.getters['theme/getCurrencySymbol'] : '';
        formattedPrice += this.formatPrice(item.price);

        return {
          inStock: inStock,
          unavailableLabel: scheduled
            ? availabilityLabel(item, (key, values) => this.$t(key, values), this.$i18n.locale)
            : null,
          value: item.article_number,
          // $pt() reads $i18n.locale here, inside the computed, so the
          // labels re-resolve when the switcher changes it. Option
          // products carry a name map only -- no description_translations.
          text: `${this.$pt(item.name_translations, item.name)} (+${formattedPrice})`,
          price: this.formatPrice(item.price),
        };
      });
    },
    typeComponent() {
      const { type } = this.dataObject;
      let typeComponent = "";
      if (type === "dropdown") {
        typeComponent = "PDropdown";
      } else if (type === "checkbox") {
        typeComponent = "PCheckboxGroup";
      } else {
        typeComponent = "PRadioGroup";
      }
      return typeComponent;
    },
  },
  watch: {
    innerValue(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      this.innerValue = newValue;
    },
    currentOptionAttr: {
      handler() {
        // need to refactor this
        this.applyChangeStyle();
      },
      deep: true,
    },
  },
};
</script>

<style>
.optional_group .v-expansion-panel-header {
  font-size: var(--fontSize, "12px") !important;
}

.optional_group .v-label {
  color: var(--fontColor, #000000) !important;
  font-size: var(--fontSize, 12px) !important;
}
</style>
